import { RunFieldsConfiguration } from "../../field-type";


export const payplugFileRunFieldsConfiguration: RunFieldsConfiguration = {

    runCursor: {
        visible: false
    },
    file: {
        visible: true,
        mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }

}